import { AssetType } from "@app/_models/enums/assetType";
import { Asset } from "@app/_models/_DTOs/asset";

export class AssetHelper {
    public static GetAssetTypePrefix(assetType: AssetType) {
        if (assetType == AssetType.OsnovnoSredstvo) {
          return "0";
        } else if (assetType == AssetType.SitniInventar) {
          return "3";
        }
        else{
            return "";
        }
    }

    public static ParseInventoryCodeNumber(asset: Asset){
      var legalEntityPrefix = "";
      var typePrefix = this.GetAssetTypePrefix(asset.type);
      if(asset.department && asset.department.legalEntity){
        legalEntityPrefix = asset.department.legalEntity.inventoryPrefix;
      }
      var inventoryCode = asset.inventoryCode;
      let re = new RegExp(`^${legalEntityPrefix}`, 'gi');
      let re2 = new RegExp(`^${typePrefix}`, "gi");
      inventoryCode = inventoryCode.replace(re, "");
      inventoryCode = inventoryCode.replace(re2, "");
      return inventoryCode;
    }
}